import React, { memo } from "react";
import { Container, Row, Spinner } from "reactstrap";

const Loader = memo(() => (
  <Container fluid className="vh-75 d-flex">
    <Row className="justify-content-center align-self-center w-100 text-center">
      <Spinner color="primary" />
    </Row>
  </Container>
));

export default Loader;
